import { render } from "./Invoices.vue?vue&type=template&id=b57b85a0&scoped=true"
import script from "./Invoices.vue?vue&type=script&lang=js"
export * from "./Invoices.vue?vue&type=script&lang=js"

import "./Invoices.vue?vue&type=style&index=0&id=b57b85a0&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/rentalkenya_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b57b85a0"]])

export default __exports__